export const swrFetcher = (url: string) => fetch(url).then((res) => res.json());
